import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SiteNav, SiteFooter, PageHero } from "@/components/SiteChrome";
import { ProductsCapabilities } from "@/components/DeepSections";

export default function ProductsPage() {
  const nav = useNavigate();
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="bg-white">
      <SiteNav />
      <PageHero eyebrow="Products & Capabilities"
        title="Precision Components For Every Industry"
        sub="Custom gears, heavy industrial gearboxes up to 2 metres, defence & strategic engineering, and reverse-engineered heavy-industry spares — built to your exact specification." />
      <ProductsCapabilities />
      <section className="bg-[#0A192F] py-16 text-center relative overflow-hidden">
        <div className="absolute inset-0 hero-lines" aria-hidden="true" />
        <div className="relative max-w-3xl mx-auto px-6">
          <h2 className="font-head font-extrabold tracked uppercase text-2xl lg:text-3xl text-white">Have A Drawing? Get A Precise Quote.</h2>
          <p className="text-slate-300 mt-4">Upload STEP / DWG / PDF files and our sourcing team routes an accurate quote directly to you.</p>
          <button onClick={() => nav("/", { state: { scrollTo: "quote" } })} className="btn-gold mt-8 inline-flex items-center gap-2 font-head font-bold text-sm tracked-sm uppercase px-8 py-4 rounded-lg">
            Upload For Quote <ArrowRight size={18} />
          </button>
        </div>
      </section>
      <SiteFooter />
    </div>
  );
}
